import { forwardRef, type Ref, type SVGProps } from "react";
const IconTeaOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22.5 8.851c.133 0 .26.05.354.14s.146.213.147.34v3.362l.248.006a5.1 5.1 0 0 1 3.286 1.402 4.72 4.72 0 0 1 1.465 3.4 4.72 4.72 0 0 1-1.465 3.399 5.1 5.1 0 0 1-3.534 1.408v3.846a3.78 3.78 0 0 1-1.174 2.719A4.1 4.1 0 0 1 19 30H8a4.1 4.1 0 0 1-1.53-.292 4 4 0 0 1-1.299-.834 3.8 3.8 0 0 1-.866-1.247A3.7 3.7 0 0 1 4 26.154V9.332a.46.46 0 0 1 .145-.342.5.5 0 0 1 .356-.139zM6 26.161c0 .51.21.999.586 1.36.375.36.883.563 1.414.563h11a2.05 2.05 0 0 0 1.412-.565A1.9 1.9 0 0 0 21 26.161V10.77h-4v5.768h1.504c.132 0 .258.051.352.141s.147.213.147.34v4.807a.48.48 0 0 1-.148.338.52.52 0 0 1-.351.143h-5a.5.5 0 0 1-.353-.141.47.47 0 0 1-.147-.34V17.02a.46.46 0 0 1 .144-.342.5.5 0 0 1 .356-.14H15V10.77H6zm9-5.77h2v-1.923l-2-.006zm8-.007c.395 0 .785-.073 1.149-.218s.694-.358.973-.626c.278-.268.499-.586.65-.936a2.8 2.8 0 0 0 0-2.207 2.9 2.9 0 0 0-.65-.936 3 3 0 0 0-.973-.625 3.1 3.1 0 0 0-1.148-.22z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M8.212 2.12a.85.85 0 0 1 .623-.099.83.83 0 0 1 .512.354.77.77 0 0 1 .102.598.8.8 0 0 1-.368.492l-.224.135a.24.24 0 0 0-.12.204q-.002.062.028.118.031.055.085.09c.231.148.426.344.57.574a1.76 1.76 0 0 1 .172 1.543c-.09.253-.238.485-.432.677l-.506.502a.83.83 0 0 1-.59.238.85.85 0 0 1-.456-.131.8.8 0 0 1-.305-.353.76.76 0 0 1 .17-.862l.504-.498a.23.23 0 0 0 .07-.196.24.24 0 0 0-.111-.178 1.86 1.86 0 0 1-.629-.672 1.77 1.77 0 0 1 .03-1.751c.156-.266.38-.49.65-.651z"
    />
    <path
      fill="currentColor"
      d="M13.154 2.12a.85.85 0 0 1 .623-.099.82.82 0 0 1 .512.354.77.77 0 0 1 .102.598.8.8 0 0 1-.367.492l-.226.135a.24.24 0 0 0-.006.411c.232.15.427.345.57.575a1.76 1.76 0 0 1 .172 1.543c-.09.253-.238.485-.432.677l-.506.502a.83.83 0 0 1-.59.238.85.85 0 0 1-.456-.131.8.8 0 0 1-.305-.353.76.76 0 0 1 .17-.862l.504-.498a.24.24 0 0 0 .058-.091q.02-.052.013-.105a.24.24 0 0 0-.112-.178 1.86 1.86 0 0 1-.629-.672 1.77 1.77 0 0 1 .03-1.751c.156-.266.38-.49.65-.651z"
    />
    <path
      fill="currentColor"
      d="M17.961 2.122a.85.85 0 0 1 .623-.098.82.82 0 0 1 .512.354.77.77 0 0 1 .102.597.8.8 0 0 1-.367.493l-.227.135a.24.24 0 0 0-.005.411c.232.15.427.345.572.575a1.77 1.77 0 0 1-.263 2.22l-.504.498a.83.83 0 0 1-.592.239.85.85 0 0 1-.457-.13.8.8 0 0 1-.306-.354.76.76 0 0 1-.05-.456.8.8 0 0 1 .22-.406l.505-.498a.24.24 0 0 0 .073-.194.25.25 0 0 0-.112-.179c-.264-.169-.48-.4-.629-.67a1.78 1.78 0 0 1 .03-1.751c.157-.266.38-.491.65-.652z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconTeaOutlineSVG);
ForwardRef.displayName = "IconTeaOutline";
export { ForwardRef as IconTeaOutline };
